module.exports = {"TXTCLI_Apply__forChanges":{"id":"TXTCLI_Apply__forChanges","defaultMessage":"Anwenden","flags":["TRACK"],"track":"Apply"}}